export default "__VITE_ASSET__D_l9r1_F__"